export const NEW_RULE_ID = 'new';
export const RULE_FORM_ID = 'rule-form';
export const RENAME_MODE = 'rename';
export const OPEN_LAYER_SELECTOR = '[role="dialog"], [role="menu"], [role="listbox"]';
